var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('h1',[_vm._v("נרשמת בהצלחה ליעוץ אישי")]),_c('p',[_vm._v("נציגינו יחזרו אלייך בקרוב עם פרטים נוספים")])])
}]

export { render, staticRenderFns }